import BaseService from '@/services/baseService';
import { AxiosResponse } from 'axios';
import { ILieferantKundenService } from './ILieferantKundenService';
import { TeilnehmerListApiDtoSearchResponseApi } from '@/api-schema';
import { TeilnehmerFilterDto } from '@/types/TeilnehmerFilterDto';

export class LieferantKundenService extends BaseService implements ILieferantKundenService {
    private RESOURCE_URL: string;

    constructor() {
        super();
        this.RESOURCE_URL = `${this.BASE_URL}teilnehmer/kunde`;
        console.debug('LieferantKundenService::constructor', this.RESOURCE_URL);
    }
    async reset(): Promise<boolean | AxiosResponse<any>> {
        return super.PUT(`${this.RESOURCE_URL}/reset`, null).then((response) => {
            return response;
        });
    }
    async getTvsKunden(filter: TeilnehmerFilterDto): Promise<TeilnehmerListApiDtoSearchResponseApi> {
        return super.GET<TeilnehmerListApiDtoSearchResponseApi>(`${this.RESOURCE_URL}${super.serializeObjectToQuerystring(filter)}`).then((response) => {
            return response;
        });
    }

    async downloadTvsKunden(filter: TeilnehmerFilterDto): Promise<AxiosResponse<File>> {
        return super
            .DOWNLOAD<TeilnehmerListApiDtoSearchResponseApi>(`${this.RESOURCE_URL}/export${super.serializeObjectToQuerystring(filter)}`)
            .then((response) => {
                return response;
            });
    }
}

export const lieferantKundenService = new LieferantKundenService();
